export const getBundleOptions = (options, optionsStock) => optionsStock ? options.filter((data) => data.id) : [];
//# sourceMappingURL=getBundleOptions.js.map